import { useMemo } from 'react';

import { useAppSelector } from 'src/app/store/hooks';
import { usePassengersListQuery } from 'src/common/external/bambi-api/bambiApi';
import { useShouldShowRideOrderingPortalFeatures } from 'src/features/rideOrderingPortal/useShouldShowRideOrderingPortalFeatures';

import {
  columnsWithDeletedAt,
  columnsWithoutDeletedAt,
  rideOrderingPortalColumns,
} from './columns';
import { PassengerDataGrid } from './PassengerDataGrid';

export function PassengerManagementRoute() {
  const shouldUseRideOrderingPortalColumns =
    useShouldShowRideOrderingPortalFeatures();

  const showDeletedPassengers = useAppSelector(
    (state) => state.passenger.showDeletedPassengers
  );

  const tableColumns = useMemo(() => {
    if (shouldUseRideOrderingPortalColumns) {
      return rideOrderingPortalColumns;
    }
    if (showDeletedPassengers) {
      return columnsWithDeletedAt;
    }
    return columnsWithoutDeletedAt;
  }, [shouldUseRideOrderingPortalColumns, showDeletedPassengers]);

  return (
    <PassengerDataGrid
      columns={tableColumns}
      useDataProvider={usePassengersListQuery}
    />
  );
}
